import { PageHeading } from "../../components/common/pageHeading/PageHeading";
import { ResetPasswordRequest } from "../../components/user/resetPasswordRequest/ResetPasswordRequest";
import styles from "./resetPassword.module.css";
export const ResetPassword = () => {
  return (
    <main className={styles.resetPassMain}>
      <PageHeading title={"Reset Your Password"} />
      <section
        className={`${styles.resetPasswordForm}  animate__animated animate__fadeIn`}
      >
        <ResetPasswordRequest />
      </section>
    </main>
  );
};
